import React, {useState} from 'react';
import {GoLocation} from 'react-icons/go';
import {BiMobileAlt} from 'react-icons/bi';
import {AiOutlineMail} from 'react-icons/ai';
import Logo from '../../Images/logoo.png';
import NewsLetter from '../../Images/icon-newsletter.png';
import { toast } from 'react-toastify';
import { Global } from '../Variables/Global';
import {GrFacebookOption} from 'react-icons/gr';
import {FaInstagram} from 'react-icons/fa';

const Footer = () => {
	const [emailNewsLetter, setEmailNewsLetter] = useState("");
	var emailregx = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
	  function isValid() {
			if (emailNewsLetter === "") {
			  toast.error("please Provide your Email");
			  return false;
			} else if (!emailregx.test(emailNewsLetter)){
			  toast.error("Bad email format");
			}else {
			  return true;
			}
		   
		}

	const HandleSubscribe = (e) => {
        e.preventDefault();
       if(isValid()){
        fetch(Global.API_URL + "NewsLetter/SubscribeToNewsLetter" , {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": Global.API_URL,
            },
            body: JSON.stringify({
              Email: emailNewsLetter,
            }),
          })
            .then((response) => {
              if (response.ok) {
                toast.success("Subscribed Successfully");
                return response.json();
              }
              return response.text().then((text) => {
                throw new Error(text);
              });
            })
       }
    }
  return (
    <>
    <footer>
		{/* <!--=======  newsletter section  =======--> */}

		<div className="newsletter-section pt-5 pb-5">
			<div className="container">
				<div className="row">
					<div className="col-lg-4 col-md-12 col-sm-12 mb-sm-2 mb-xs-2">
						{/* <!--=======  newsletter title =======--> */}

						<div className="newsletter-title">
							<h1>
								
								<img width="37" height="28" src={NewsLetter} alt="Ossakbire NewsLetter" />
								<span>
								Send Newsletter
								</span>
							</h1>
						</div>

						{/* <!--=======  End of newsletter title  =======--> */}
					</div>

					<div className="col-lg-8 col-md-12 col-sm-12">
						{/* <!--=======  subscription-form wrapper  =======--> */}

						<div className="subscription-form-wrapper d-flex flex-wrap flex-sm-nowrap">
							<p className="mb-xs-2">Sign up for our newsletter to get up-to-date from us</p>
							<div className="subscription-form">
								{/* id="mc-form" className="mc-form subscribe-form" */}
								<form onSubmit={HandleSubscribe}>
									<input type="email" id="mc-email" autoComplete="off"
										placeholder="Your email address"  onChange={(e) => setEmailNewsLetter(e.target.value)} />
									<button id="mc-submit" type="submit"> subscribe!</button>
								</form>

								{/* <!-- mailchimp-alerts Start --> */}
								<div className="mailchimp-alerts">
									<div className="mailchimp-submitting"></div>
									<div className="mailchimp-success"></div>
									<div className="mailchimp-error"></div>
								</div>
							</div>
						</div>

						{/* <!--=======  End of subscription-form wrapper  =======--> */}
					</div>
				</div>
			</div>
		</div>

		{/* <!--=======  End of newsletter section  =======--> */}

		{/* <!--=======  social contact section  =======--> */}

		<div className="social-contact-section pt-5 pb-5">
			<div className="container">
				<div className="row">
					<div className="col-lg-4 col-md-12 order-2 order-md-2 order-sm-2 order-lg-1">
						{/* <!--=======  social media links  =======--> */}

						<div className="social-media-section">
							<h2>Follow us</h2>
							<div className="social-links">
								<a className="facebook" href="https://www.facebook.com/ossakbireuae" data-tooltip="Facebook">
									{/* <i className="fa fa-facebook"></i> */}
										<GrFacebookOption />
									</a>

									<a className="instagram" href="https://www.instagram.com/ossakbireuae/" data-tooltip="Instagram">
										{/* <i className="fa fa-instagram"></i> */}
										<FaInstagram />
										</a>		
								{/* <!-- <a className="twitter" href="http://www.twitter.com" data-tooltip="Twitter"><i
										className="fa fa-twitter"></i></a>
								
								<a className="linkedin" href="http://www.linkedin.com" data-tooltip="Linkedin"><i
										className="fa fa-linkedin"></i></a>
								<a className="rss" href="http://www.rss.com" data-tooltip="RSS"><i
										className="fa fa-rss"></i></a> --> */}
							</div>
						</div>

						{/* <!--=======  End of social media links  =======--> */}

					</div>
					<div className="col-lg-8 col-md-12 order-1 order-md-1 order-sm-1 order-lg-2  mb-sm-50 mb-xs-50">
						{/* <!--=======  contact summery  =======--> */}

						<div className="contact-summery">
							<h2>Contact us</h2>

							{/* <!--=======  contact segments  =======--> */}

							<div className="contact-segments d-flex justify-content-between flex-wrap flex-lg-nowrap">
								{/* <!--=======  single contact  =======--> */}

								<div className="single-contact d-flex mb-xs-20">
									<div className="icon">
										{/* <span className="icon_pin_alt"></span> */}
										<GoLocation />
									</div>
									<div className="contact-info">
										<p>Address: <span>Dubai - UAE</span></p>
									</div>
								</div>

								{/* <!--=======  End of single contact  =======--> */}
								{/* <!--=======  single contact  =======--> */}

								<div className="single-contact d-flex mb-xs-20">
									<div className="icon">
										{/* <span className="icon_mobile"></span> */}
										<BiMobileAlt />
									</div>
									<div className="contact-info">
									
										<p>Phone: <br/> <a className='RemUnderlineFH' href="tel:+971505797151"><span>+971 58 206 0373 </span></a></p>
									</div>
								</div>

								{/* <!--=======  End of single contact  =======--> */}
								{/* <!--=======  single contact  =======--> */}

								<div className="single-contact d-flex">
									<div className="icon">
										{/* <span className="icon_mail_alt"></span> */}
										<AiOutlineMail />
									</div>
									<div className="contact-info">
										<p>Email: <br/> <a className='RemUnderlineFH' href="mailto:info@ossakbire.com"><span>info@ossakbire.com</span></a></p>
									</div>
								</div>

								{/* <!--=======  End of single contact  =======--> */}
							</div>

							{/* <!--=======  End of contact segments  =======--> */}



						</div>

						{/* <!--=======  End of contact summery  =======--> */}

					</div>
				</div>
			</div>
		</div>

		{/* <!--=======  End of social contact section  =======--> */}

		{/* <!--=======  footer navigation  =======--> */}

		<div className="footer-navigation-section pt-4 pb-4">
			<div className="container">
				<div className="row">
					<div className="col-lg-3 col-md-3 col-sm-6 col-xs-12 mb-xs-3">
						<div className="single-navigation-section">

						<a  href="/"><img width="200" height="130" src={Logo}  alt="OssaKbire Logo" /></a>

						</div>
					</div>

					<div className="col-lg-3 col-md-3 col-sm-6 col-xs-12 mb-xs-30">
						{/* <!--=======  single navigation section  =======--> */}

						<div className="single-navigation-section">
							<h3 className="nav-section-title">SITE MAP</h3>
							<ul>
								<li><a className='RemUnderlineHF' href="/Shop">Shop</a></li>
								<li><a className='RemUnderlineHF' href="/Authentication">Login</a></li>
								{/* <!-- <li><a href="shop.html"></a></li> --> */}
								<li><a className='RemUnderlineHF' href="/Contact">Contact</a></li>
							</ul>
						</div>

						{/* <!--=======  End of single navigation section  =======--> */}
					</div>








					<div className="col-lg-3 col-md-3 col-sm-6 col-xs-12 mb-xs-3">
						{/* <!--=======  single navigation section  =======--> */}

						<div className="single-navigation-section">
							<h3 className="nav-section-title">CATEGORIES</h3>
							<ul>
								<li> <a className='RemUnderlineHF' href="/Category/JALLAB-SYRUP/5">JALLAB - SYRUP</a></li>
								<li> <a className='RemUnderlineHF' href="/Category/OLIVES/8">OLIVES</a></li>
								<li> <a className='RemUnderlineHF' href="/Category/TAHINA/12">TAHINA - MOLASSES</a></li>
							
							</ul>
						</div>

						{/* <!--=======  End of single navigation section  =======--> */}
					</div>
					<div className="col-lg-3 col-md-3 col-sm-6 col-xs-12 mb-xs-3">
						{/* <!--=======  single navigation section  =======--> */}

						<div className="single-navigation-section">
							<h3 className="nav-section-title">CATEGORIES</h3>
							<ul>
								<li> <a className='RemUnderlineHF' href="/Category/PICKLES/10">PICKLES</a></li>
								<li> <a className='RemUnderlineHF' href="/Category/JAMS/6">JAMS</a></li>
								<li> <a className='RemUnderlineHF' href="/Category/SUMAC-KESHEK/11">SUMAC - KESHEK</a></li>
								
							</ul>
						</div>




					</div>

		








					{/* <!-- <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12 mb-xs-30">
						<!--=======  single navigation section  =======-->

					<!-- <div className="single-navigation-section">
							<h3 className="nav-section-title">CUSTOMER SERVICE</h3>
							<ul>
								<li> <a href="contact.html">Contact</a></li>
								<li> <a href="#">OUR SERVICE</a></li>
								<li> <a href="#">RETURNS</a></li>
								<li> <a href="#">SITE MAP</a></li>
							</ul>
						</div> -->

					<!--=======  End of single navigation section  =======-->
					<!-- </div>
					 --> */}








					{/* <!-- 					
					<div className="col-lg-3 col-md-3 col-sm-6 col-xs-12"> --> */}
					{/* <!--=======  single navigation section  =======--> */}
					{/* <!-- 
						<div className="single-navigation-section">
							<h3 className="nav-section-title">Extras</h3>
							<ul>
								<li> <a href="contact.html">BRANDS</a></li>
								<li> <a href="#">GIFT VOUCHERS</a></li>
								<li> <a href="#">AFFILIATES</a></li>
								<li> <a href="#">SPECIALS</a></li>
							</ul>
						</div> --> */}

					{/* <!--=======  End of single navigation section  =======--> */}
					 {/* </div> */}
				</div>
			</div>
		</div>

		{/* <!--=======  End of footer navigation  =======--> */}


		{/* <!--=======  copyright section  =======--> */}

		<div className="copyright-section pt-3 pb-3">
			<div className="container">
				<div className="footerbottom">
					<p >&copy; 2023 <a target="_blank" href="https://hyveonline.com/"> HyveOnline </a>. All rights reserved.</p>	
				</div>     
				
				{/* <!-- <div className="row align-items-md-center align-items-sm-center">
					<div className="col-lg-8 col-md-6 col-sm-12 col-xs-12 text-center text-md-start"> -->
						<!--=======  copyright text	  =======-->

						<!-- <div className="copyright-segment"> -->
							<!-- <p>
								<a href="#">Privacy Policy</a>
								<span className="separator">|</span>
								<a href="#">Term and conditions</a>
							</p> -->
							<!-- <p className="copyright-text">&copy; 2023 <a href="/"> HyveOnline </a>. All rights reserved.</p> -->
						<!-- </div> -->

						<!--=======  End of copyright text	  =======-->

					<!-- </div> -->
					<!-- <div className="col-lg-8 col-md-6 col-sm-12 col-xs-12"> -->
						<!--=======  payment info  =======-->

						<!-- <div className="payment-info text-center text-md-end">
							<p>Allow payment base on <img width="316" height="44" src="assets/images/payment-icon.webp"
									className="img-fluid" alt=""></p>
						</div> -->

						<!--=======  End of payment info  =======-->
<!-- 
					</div> -->
				<!-- </div> --> */}
			</div>
		</div>

		{/* <!--=======  End of copyright section  =======--> */}
	</footer>
    </>
  )
}

export default Footer